export const loginForm = {
  identifier: 'login',
  buttonlabel: 'Generate Otp',
  inputStyleType: 'rounded',
  fields: [
    {
      identifier: 'login-field',
      fields: [
        {
          identifier: 'login:pan',
          label: 'PAN Number',
          type: 'text',
          max: 10,
          regex: '^([a-zA-Z]){3}([CPHFATBLJG]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$',
        },
        {
          identifier: 'login:mobile',
          label: 'Mobile Number',
          type: 'number',
          max: 10,
          regex: /^[5-9]\d{9}$/,
        },
      ]
    }
  ]
}